<template>
    <div>
        <div class="right_table">
            <div class="report_query_box">
                <div class="report_query_btns">
                    <a-button class="func_btn_item" type="primary" @click="searchData">查询</a-button>
                    <a-button class="func_btn_item" type="primary" @click="exportData"> 导出</a-button>
                </div>
            </div>

            <a-table
                    :columns="columns"
                    :data-source="tableData"
                    :key="1"
                    bordered
                    :pagination="false"
                    :loading="loading"
                    size="middle"
            />
        </div>
    </div>
</template>
<script>
    import {dataApi} from "@/services/report/report.js";
    import api from "@/services/api";
    // 多表头 固定表头
    const columns = [
        {
            title: '经理部',
            field: "regionName",
            dataIndex: 'regionName',
            key: 'regionName',
            width: 80,
            align: 'center',
            className: 'bg-color',
        },
        {
            title: '昨日新增',
            field: 'daySum',
            dataIndex: 'daySum',
            key: 'daySum',
            width: 80,
            align: 'center',
            className: 'bg-color',
        },
        {
            title: '本月新增',
            field: 'monthSum',
            dataIndex: 'monthSum',
            key: 'monthSum',
            width: 80,
            align: 'center',
            className: 'bg-color',
        },
        {
            title: '年度累计',
            field: 'yearSum',
            dataIndex: 'yearSum',
            key: 'yearSum',
            width: 80,
            align: 'center',
            className: 'bg-color',
        },
        {
            title: '待确认档案数',
            field: 'notPrintSum',
            dataIndex: 'notPrintSum',
            key: 'notPrintSum',
            width: 80,
            align: 'center',
            className: 'bg-color',
        },

    ];

    export default {
        components: {
        },
        data() {
            return {
                dateDefaultDate: [],
                loading: false,
                tableData: [],
                columns,
                //  新增的结束
                search: {
                    page: 1,
                    limit: 10,
                }
            };
        },
        created() {
        },
        async mounted() {
            this.getTableData();
        },
        methods: {
            getTableData() {
                this.loading = true;
                dataApi.mainCustReport().then(res => {
                    console.log('tableData', res)
                    this.loading = false;
                    let resData = res.data;
                    if (!resData.length) {
                        console.log('暂无数据');
                        this.tableData = [];
                        return false;
                    }
                    this.tableData =resData;
                });
            },
            //重置
            resetData() {
                //新增的
                this.getTableData()
            },
            // 搜索
            async searchData() {
                this.getTableData()
            },
            async exportData() {
                if (!this.tableData || this.tableData.length <= 0) {
                    this.$message.error('当前没有数据可导出')
                    return false
                }
                const params = {
                    filename: "月度新车保客档案信息报表",
                    containHeader: true,
                    fields: [{title: "序号"},
                        {field: "regionName", title: "经理部"},
                        {field: "daySum", title: "昨日新增"},
                        {field: "monthSum", title: "本月新增"},
                        {field: "yearSum", title: "年度累计"},
                        {field: "notPrintSum", title: "待确定归档数"}
                        ],
                    ids: [0],
                    original: false,
                    sheetName: "后台管理端 | 月度新车保客档案信息报表"
                }
                this.loading = true;
                await dataApi.exportFile(api.report.REPORT + "/mainCustReportExport",params).then(blob => {
                    this.loading = false;
                    this.$message.success('正在导出，请在下载中心下载');
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob.data); //创建下载的链接
                    downloadElement.href = href;
                }).catch(e => {
                    console.error('导出失败:' + e);
                    this.$message.error('导出失败');
                })
            },
        }
    };
</script>

<style scoped lang="less">
    .report_query_box {
        padding: 30px 12px;
        display: flex;
        flex-wrap: wrap;

        .item_box {
            margin-right: 20px;
            margin-bottom: 12px;
        }

        .func_btn_item {
            margin-left: 12px;
            align-self: flex-end;
        }
    }
</style>
